import type {
  InvestorDetail,
  InvestorFundRelationship,
  InvestorSummary,
} from '@/types/investor';

export interface TransfereeCandidate {
  id: string;
  name: string;
  isExistingFundInvestor: boolean;
}

export function getRelationshipForFund(
  investor: InvestorDetail,
  fundId: string
): InvestorFundRelationship | undefined {
  return investor.fund_relationships.find(
    (relationship) => relationship.fund_id === fundId
  );
}

function isActiveRelationship(
  relationship?: InvestorFundRelationship | null
): boolean {
  return relationship?.status?.toLowerCase() === 'active';
}

export function buildTransfereeCandidates(
  fundInvestors: InvestorDetail[],
  investorsOutsideFund: InvestorSummary[]
): TransfereeCandidate[] {
  return [
    ...fundInvestors.map((fundInvestor) => ({
      id: fundInvestor.id,
      name: fundInvestor.name,
      isExistingFundInvestor: true,
    })),
    ...investorsOutsideFund.map((investorOutsideFund) => ({
      id: investorOutsideFund.id,
      name: investorOutsideFund.name,
      isExistingFundInvestor: false,
    })),
  ];
}

export function getAvailableTransfereesForInvestor(
  transferorInvestorId: string,
  transfereeCandidates: TransfereeCandidate[]
): TransfereeCandidate[] {
  return transfereeCandidates.filter(
    (candidate) => candidate.id !== transferorInvestorId
  );
}

export function getTransferorCandidates(
  investors: InvestorDetail[],
  fundId: string
): InvestorDetail[] {
  return investors.filter((investor) =>
    isActiveRelationship(getRelationshipForFund(investor, fundId))
  );
}
